import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { fmtDate } from "@/lib/format";
import { cleanParams, fmtValue } from "@/lib/analytics";
import { Panel, SectionLabel, StatusBadge } from "@/components/common/ui-kit";
import { Button } from "@/components/ui/button";

const Tile = ({ x, unit, onDrill, testId }) => (
  <button type="button" onClick={() => onDrill(x.drill)} className="rounded-xl border border-line bg-white p-3 text-left hover:bg-slate-50" data-testid={testId}>
    <p className="text-xs text-slate-500">{x.label}</p><p className="mt-0.5 text-lg font-semibold text-ink">{fmtValue(x.value, unit)}{unit === "money" && <span className="ml-1 text-[11px] font-normal text-slate-400">imponibile</span>}</p></button>
);

// fotografia della relazione: solo dati reali e segnali spiegabili, nessun punteggio arbitrario
export const CustomerSnapshot = ({ cid, filters, onDrill, onClose }) => {
  const [d, setD] = useState(null);
  useEffect(() => { setD(null); api.get(`/analytics/customers/${cid}`, { params: cleanParams(filters) }).then((r) => setD(r.data)).catch(() => setD({ error: true })); }, [cid, filters]);
  if (!d) return null;
  if (d.error) return <Panel className="p-5 text-sm text-slate-500" data-testid="customer-snapshot-error">Cliente non disponibile nel tuo perimetro.</Panel>;
  return (
    <Panel className="space-y-4 p-5" data-testid="customer-snapshot">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div><SectionLabel>Fotografia cliente</SectionLabel><Link to={`/clienti/${d.company.id}`} className="text-lg font-semibold text-ink hover:underline" data-testid="customer-snapshot-name">{d.company.name}</Link></div>
        <Button size="sm" variant="ghost" onClick={onClose} data-testid="customer-snapshot-close">Chiudi</Button>
      </div>
      <div className="grid grid-cols-2 gap-2 md:grid-cols-4">{d.counts.map((x, i) => <Tile key={x.label} x={x} unit="int" onDrill={onDrill} testId={`customer-count-${i}`} />)}</div>
      {!!d.values.length && <div className="grid grid-cols-2 gap-2 md:grid-cols-4">{d.values.map((x, i) => <Tile key={x.label} x={x} unit="money" onDrill={onDrill} testId={`customer-value-${i}`} />)}</div>}
      <div className="grid gap-3 text-sm md:grid-cols-2">
        <p data-testid="customer-last-activity"><span className="text-slate-500">Ultima attività: </span>{d.last_activity ? `${d.last_activity.title} · ${fmtDate(d.last_activity.completed_at)}` : "—"}</p>
        <p data-testid="customer-next-activity"><span className="text-slate-500">Prossima attività: </span>{d.next_activity ? `${d.next_activity.title} · ${fmtDate(d.next_activity.due_at)}` : "—"}</p>
      </div>
      <div className="flex flex-wrap gap-2" data-testid="customer-signals">
        {d.signals.map((s, i) => <button key={i} type="button" disabled={!s.drill} onClick={() => onDrill(s.drill)} data-testid={`customer-signal-${i}`}>
          <StatusBadge tone={s.tone}>{s.label}</StatusBadge></button>)}
        {!d.signals.length && <StatusBadge tone="green">Nessun segnale di attenzione</StatusBadge>}
      </div>
    </Panel>
  );
};
